/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RansomwareResourceNotificationArguments {
  /**
  * Cloud-provider-assigned resource ID.
  */
  'providerResourceId'?: string;
  /**
  * Resource display name.
  */
  'resourceName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RansomwareResourceNotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

